// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"d9695e76","343":"0643a42c","453":"9c650557","570":"36546287","723":"e0747039","970":"a67765ce"}[chunkId] + ".chunk.js";
};